<template>
  <div class="editar-perfil">
    <Sidebar />

    <div class="contenido">
      <h1>Editar Perfil</h1>

      <form @submit.prevent="guardarCambios" enctype="multipart/form-data" class="formulario">
        <div v-if="previewFoto" class="preview">
          <img :src="previewFoto" alt="Vista previa" />
        </div>

        <div class="campo">
          <label for="foto_perfil">Cambiar foto de perfil</label>
          <input type="file" @change="handleFoto" id="foto_perfil" />
        </div>

        <div class="campo">
          <label for="usuario">Usuario</label>
          <input type="text" v-model="form.usuario" id="usuario" disabled />
        </div>

       <div class="campo password-field">
  <label for="password">Nueva contraseña</label>
  <div class="input-con-icono">
    <input
      :type="mostrarPassword ? 'text' : 'password'"
      v-model="form.nueva_password"
      id="password"
      placeholder="Opcional"
    />
    <span class="icono" @click="mostrarPassword = !mostrarPassword">
      {{ mostrarPassword ? '🙈' : '👁️' }}
    </span>
  </div>
</div>

        <div class="campo">
          <label for="nombre_completo">Nombre completo</label>
          <input type="text" v-model="form.nombre_completo" id="nombre_completo" />
        </div>

        <div class="campo">
          <label for="email">Correo electrónico</label>
          <input type="email" v-model="form.email" id="email" />
        </div>

        <button type="submit">Guardar cambios</button>
      </form>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import { EventBus } from '@/eventBus.js';
import axios from 'axios';

export default {
  name: 'EditarPerfil',
  components: { Sidebar },
  data() {
    return {
      form: {
        usuario: '',
        nueva_password: '',
        nombre_completo: '',
        email: '',
        foto_perfil: null
        

      },
      previewFoto: null,
      mostrarPassword: false
    };
  },
  mounted() {
    this.obtenerDatosPerfil();
  },
  methods: {
    async obtenerDatosPerfil() {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get('http://localhost:3000/api/administradores/perfil', {
          headers: { Authorization: `Bearer ${token}` }
        });

        const { usuario, nombre_completo, email } = response.data;
        this.form.usuario = usuario;
        this.form.nombre_completo = nombre_completo;
        this.form.email = email;

        // Aquí puedes cargar una URL real si tu backend lo permite
        // this.previewFoto = response.data.foto_perfil_url;
      } catch (error) {
        console.error('Error al obtener perfil:', error);
      }
    },
    handleFoto(e) {
      const file = e.target.files[0];
      this.form.foto_perfil = file;
      if (file) {
        this.previewFoto = URL.createObjectURL(file);
      }
    },
   async guardarCambios() {
  try {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('nombre_completo', this.form.nombre_completo);
    formData.append('email', this.form.email);

    if (this.form.nueva_password) {
      formData.append('nueva_password', this.form.nueva_password);
    }

    if (this.form.foto_perfil) {
      formData.append('foto_perfil', this.form.foto_perfil);
    }

    const response = await axios.put('http://localhost:3000/api/administradores/perfil', formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });

    // ✅ EMITIR nombre y foto actualizados al Sidebar
    EventBus.$emit('nombreActualizado', this.form.nombre_completo);
    
    if (response.data.foto_perfil) {
      EventBus.$emit('fotoActualizada', response.data.foto_perfil);
    }

    alert(response.data.mensaje || 'Perfil actualizado correctamente');
  } catch (error) {
    console.error('Error al guardar cambios:', error);
    alert('Ocurrió un error al actualizar el perfil');
  }
}

    
  }
};
</script>

<style scoped>
.editar-perfil {
  display: flex;
}

.contenido {
  margin-left: 260px;
  padding: 2rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-height: 100vh;
  background-color: #f7f7f7;
}

h1 {
  margin-bottom: 1.5rem;
  font-weight: 700;
  font-size: 2rem;
}

.formulario {
  max-width: 500px;
  width: 100%;
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.preview {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.preview img {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #1976d2;
}

.campo {
  display: flex;
  flex-direction: column;
}

label {
  font-weight: 600;
  margin-bottom: 0.4rem;
}

input[type="text"],
input[type="password"],
input[type="email"],
input[type="file"] {
  padding: 0.6rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
}

button {
  padding: 0.75rem;
  background-color: #1976d2;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

button:hover {
  background-color: #145a9c;
}

.input-con-icono {
  position: relative;
  display: flex;
  align-items: center;
}

.input-con-icono input {
  flex: 1;
  padding-right: 2.5rem; /* espacio para el ícono */
}

.input-con-icono .icono {
  position: absolute;
  right: 0.75rem;
  cursor: pointer;
  user-select: none;
  font-size: 1.2rem;
}

</style>
